export enum CacheStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

export interface MessageItem {
  chatName: string;
  id: string;
  cached: boolean;
  userId: string;
  conversationId: string;
  // Note: technically, this is the actual message ID, and id is actually the cache entry ID. For now, we are ignoring this.
  // messageId: string;
  userMessage: string;
  sqlQuery: string;
  botResponse: string;
  created: string;
  lastUpdated: string;
  // Who last edited this entry and when, as returned by the admin read
  // endpoints. Both are null for an entry no admin has edited; both are absent
  // from the response entirely if it came from an API build that predates
  // attribution, which is why every consumer treats absent and null alike.
  lastChangedBy: string | null;
  lastChangedAt: string | null;
  cacheStatus: CacheStatus;
  cacheType: string;
  redisKey: string;
}

/**
 * Sort keys the cached-messages list endpoint accepts. `senderName` is not a field
 * of `MessageItem`: the endpoint resolves the sender's display name itself and
 * orders the full result set by it before paging, because a client holding one page
 * cannot order the whole list.
 */
export type CachedMessagesSortKey = keyof MessageItem | "senderName";

export interface GetCachedMessagesQueryParams {
  page: number;
  pageSize: number;
  sortBy?: CachedMessagesSortKey;
  sortOrder?: "asc" | "desc";
  userId?: string;
  cacheStatus?: CacheStatus;
  search?: string;
}

export interface GetCachedMessagesPagination {
  totalItems: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetCachedMessagesResult {
  messages: MessageItem[];
  pagination: GetCachedMessagesPagination & {
    page: number;
    pageSize: number;
  };
}

export enum UpdateCacheAction {
  CACHE = "cache",
  UNCACHE = "uncache",
  CLEAR = "clear",
}

export interface UpdateCachedMessageRequestBody {
  action: UpdateCacheAction;
  messageIds?: string[];
}
